// extracted by mini-css-extract-plugin
export var dividerLine = "_4j-0";
export var errorBackground = "_4j-1";